//Style
require('./referralsPromotions.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @utilities
const { PAGE_NAMES, tagReferralsPage } = require('utilities/taggingReferralsHelper');
// @components
const ReferralsPromotionBox = require('components/referralsPromotionBox/referralsPromotionBox');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class ReferralsPromotions extends React.Component {

    componentDidMount() {
        tagReferralsPage(PAGE_NAMES.PROMOTIONS);
    }

    render() {
        const {
            immReferrals,
            immMgmCMSNodes,
            referralsGetPromotionsList
        } = this.props;
        let content;
        if (immReferrals.get('promotionsIsFetching')) {
            content = (<LoadingSection />);
        } else if (immReferrals.get('promotionsError')) {
            const retryButton = (
                <OKButton onClick={referralsGetPromotionsList}>
                    <FormattedText value="common-retry" />
                </OKButton>
            );
            content = (
                <div className="referrals-promotions__empty-state">
                    <EmptyState primaryText={formatText('referrals-errorState')} button={retryButton} iconType="nointernet-banking"/>
                </div>
            );

        } else if (immReferrals.get('promotionsSuccess') && immReferrals.get('promotionsList').size > 0) {
            content = immReferrals.get('promotionsList').map((immPromotion, index) => {
                const immPromotionDetails = immMgmCMSNodes.find(immMGMPromotion => immMGMPromotion.get('code') === immPromotion.get('promotionCode'));
                const publicId = !!immPromotionDetails ? immPromotionDetails.get('public_id') : '';
                return (
                    <ReferralsPromotionBox
                        key={index}
                        promotionSelected={immPromotion}
                        publicId={publicId}
                    />
                );
            });
        } else {
            content = (
                <div className="referrals-promotions__empty-state">
                    <EmptyState primaryText={formatText('referrals-noPromotions')} iconType="search-banking" />
                </div>
            );
        }

        return (
            <div className="referral-promotions">
                {content}
            </div>
        );
    }
}

ReferralsPromotions.propTypes = {
    immReferrals: PropTypes.object.isRequired,
    immMgmCMSNodes: PropTypes.object.isRequired,
    referralsGetPromotionsList: PropTypes.func.isRequired
};

module.exports = ReferralsPromotions;
